/* eslint-disable */
import React, { useState } from 'react';
import {
  Dialog, Box, Typography, TextField, Button, IconButton, InputAdornment, CircularProgress,
} from '@mui/material';

const CloseIconBold = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
    <path d="M18 6L6 18M6 6l12 12" stroke="#385576" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

import toast from 'Utils/toast';
import { addUser } from '../UsersService';
import copyIcon from 'Images/copy_icon.svg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import { ReactComponent as GenerateIcon } from 'Images/generate_icon.svg';
const SaveIconWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15.453" height="15.453" viewBox="0 0 15.453 15.453">
    <g transform="translate(-3.25 -3.25)">
      <path d="M16.4,17.953H5.55A1.55,1.55,0,0,1,4,16.4V5.55A1.55,1.55,0,0,1,5.55,4h8.527l3.876,3.876V16.4A1.55,1.55,0,0,1,16.4,17.953Z" transform="translate(0 0)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M16.778,17.4V11.444H9.333V17.4m0-13.4V7.722h5.955" transform="translate(-2.356 0)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </g>
  </svg>
);

import { generatePassword, inputSx } from './utils';

const CreateAccountDialog = ({ clientCode, onClose, onSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGenerate = () => setPassword(generatePassword());

  const handleCopy = () => {
    if (!password) return;
    navigator.clipboard.writeText(password);
    toast.success('Mot de passe copié');
  };

  const handleSubmit = async () => {
    if (!username || !password) return;
    setLoading(true);
    try {
      await addUser({ username, password, role: 'ROLE_CLIENT', clientCode });
      toast.success('Compte créé avec succès');
      onClose();
      if (onSuccess) onSuccess();
    } catch (e) {
      toast.error(e?.response?.data?.statusLabel || 'Erreur lors de la création du compte');
      setLoading(false);
    }
  };


  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '8px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
          padding: 0,
          overflow: 'hidden',
          marginBottom: '370px',
        },
      }}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0, 37, 59, 0.28)' } } }}
    >
      <Box sx={{ py: '16px',px:'20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>

        {/* Title */}
        <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#385576' }}>
          Créer un nouveau compte
        </Typography>

        {/* Username */}
        <TextField
          fullWidth
          placeholder="Nom d'utilisateur"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={inputSx}
        />

        {/* Password + Générer */}
        <Box sx={{ display: 'flex', gap: '14px' }}>
          <TextField
            fullWidth
            placeholder="Mot de passe"
            value={password}
            disabled
            size="small"
            sx={inputSx}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={handleCopy} disabled={!password} sx={{ color: '#8397AE' }}>
                    <img src={copyIcon} alt="copy" style={{ width: 15, height: 15 }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            onClick={handleGenerate}
            variant="outlined"
            startIcon={<GenerateIcon style={{ width: 14, height: 14 }} />}
            sx={{
              whiteSpace: 'nowrap',
              height: 45,
              px: '28px',
              fontSize: '14px',
              fontWeight: 600,
              color: '#395576',
              borderColor: '#D1D5DB',
              borderRadius: '8px',
              textTransform: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
              '&:hover': { borderColor: '#385576', backgroundColor: '#F8FAFC' },
              '& .MuiButton-startIcon': { marginRight: '4px' },
            }}
          >
            Générer
          </Button>
        </Box>

        {/* Buttons */}
        <Box sx={{ display: 'flex', gap: '12px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            startIcon={<CloseIconBold />}
            sx={{
              flex: 1,
              height: 48,
              fontWeight: 600,
              fontSize: '14px',
              color: '#385576',
              borderColor: '#E6E7EA',
              borderRadius: '8px',
              textTransform: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
              '&:hover': { borderColor: '#385576', backgroundColor: '#FFFFFF' },
              '& .MuiButton-startIcon': { marginRight: '4px' },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={loading}
            startIcon={loading ? null : <SaveIconWhite />}
            sx={{
              flex: 1,
              height: 48,
              fontWeight: 600,
              fontSize: '14px',
              backgroundColor: '#007BC6',
              color: '#FFFFFF',
              borderRadius: '8px',
              textTransform: 'none',
              boxShadow: '0 2px 8px rgba(0,123,198,0.25)',
              '&:hover': { backgroundColor: '#005F9E', boxShadow: '0 2px 8px rgba(0,123,198,0.25)' },
              '&.Mui-disabled': { backgroundColor: '#007BC6', opacity: 0.7 },
              '& .MuiButton-startIcon': { marginRight: '8px' },
            }}
          >
            {loading ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : 'Enregistrer'}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CreateAccountDialog;